module.exports = __webpack_public_path__ + "img/xinjin5.15ad402c.png";